import { render, staticRenderFns } from "./addTagsToAnswers.vue?vue&type=template&id=d46ff150&scoped=true&"
import script from "./addTagsToAnswers.vue?vue&type=script&lang=js&"
export * from "./addTagsToAnswers.vue?vue&type=script&lang=js&"
import style0 from "./addTagsToAnswers.vue?vue&type=style&index=0&id=d46ff150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46ff150",
  null
  
)

export default component.exports